import React from 'react';
import Text from '@service-victoria/component-library/components/Text';

export default function Unavailable() {
  return (
    <>
      <Text.Heading.H2 style={{ fontWeight: 'bold' }}>ALLOCATION EXHAUSTED</Text.Heading.H2>
      <Text.Body>
        The allocation of 40,000 vouchers for the Melbourne Travel Voucher Scheme has now been
        exhausted.
      </Text.Body>
      <Text.Body>
        Thank you for your interest and your continued support of tourism businesses in Victoria.
      </Text.Body>
    </>
  );
}
